export default __webpack_public_path__ + "static/media/ulagos_bco-11.a3f530cc.png";